import { api } from './client';
import type { Category, City, Language, Tag } from '@/types/domain';

export async function fetchCategories(): Promise<{ results: Category[] }> {
  return api.get('/categories/');
}

export async function fetchCities(): Promise<{ results: City[] }> {
  return api.get('/cities/');
}

export async function fetchLanguages(): Promise<{ results: Language[] }> {
  return api.get('/languages/');
}

export async function fetchTags(categorySlug?: string): Promise<{ results: Tag[] }> {
  return api.get('/tags/', { query: { category: categorySlug } });
}
